import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TopUpInstructions } from '../../types';
import { customersComponentApi } from '../services/customers';

export interface TopUpPanelState {
  topUpInstrusctions?: TopUpInstructions;
}

const initialState: TopUpPanelState = {};

export const topUpPanelSlice = createSlice({
  name: 'topUpPanel',
  initialState,
  reducers: {
    clearTopUpInstruction: (state) => {
      state.topUpInstrusctions = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      customersComponentApi.endpoints.getCustomersTopUpInstructions
        .matchFulfilled,
      (state, action: PayloadAction<{ data: TopUpInstructions }>) => {
        state.topUpInstrusctions = action.payload.data;
      },
    );
  },
});

export const { clearTopUpInstruction } = topUpPanelSlice.actions;

export default topUpPanelSlice.reducer;
